angular.module('rjmNg.api').factory("EmailSummary", [
  "$cacheFactory"
  "$http"
  "$resource"
  "app"
  "emailSummaryEnums"
  "logger"
  "serviceUrl"
  ($cacheFactory, $http, $resource, app, emailSummaryEnums, logger, serviceUrl) ->
 
    _actionUrls =
      base: serviceUrl("/clients/#{app.getClientId()}/email-summaries")
      edit: serviceUrl("/clients/#{app.getClientId()}/email-summaries/:esId")
      send: serviceUrl("/clients/#{app.getClientId()}/email-summaries/:esId/send")

    # https://docs.angularjs.org/api/ng/service/$http#overriding-the-default-transformations-per-request
    _appendTransform = (defaults, transform) ->
      defaults = if(angular.isArray(defaults)) then defaults else [defaults]
      return defaults.concat(transform);

    _addOrigin = (responseVal) ->
      if responseVal?
        responseVal.reqOrigin = 'EmailSummary'
      else
        responseVal =
          reqOrigin: 'EmailSummary'
      return responseVal

    _defaultParams = 
      withCredentials: true
      headers:
        Accept: 'application/json'
        'Content-Type': 'application/json'
      transformResponse: _appendTransform($http.defaults.transformResponse, _addOrigin)

    _actions =
      get: angular.extend({}, _defaultParams,{
        method: 'GET'
        url: _actionUrls.edit
        cache: $cacheFactory.get('EmailSummary.get') or $cacheFactory('EmailSummary.get')
      })
      getAll: angular.extend({}, _defaultParams,{
        isArray: true
        method: 'GET'
        url: _actionUrls.base
        cache: $cacheFactory.get('EmailSummary.getAll') or $cacheFactory('EmailSummary.getAll')
      })
      create: angular.extend({}, _defaultParams,{
        method: 'POST'
        url: _actionUrls.base
      })
      update: angular.extend({}, _defaultParams,{
        method: 'PATCH'
        url: _actionUrls.edit
      })
      delete: angular.extend({}, _defaultParams,{
        method: 'DELETE'
        url: _actionUrls.edit
      })
      send: angular.extend({}, _defaultParams,{
        method: 'POST'
        url: _actionUrls.send
      })

    _resource = $resource("", {}, _actions)

    _get = (esId) ->
      return _resource.get({esId}).$promise

    _getAll = () ->
      return _resource.getAll().$promise

    _getMetaData = () ->
      reqObj = angular.extend({}, _defaultParams, {
        cache: true,
        method: 'GET',
        url: serviceUrl("/clients/#{app.getClientId()}/email-summaries-metadata")
      })
      return $http(reqObj)

    _getMigratedSummaries = () ->
      reqObj = angular.extend({}, _defaultParams, {
        cache: true,
        method: 'GET',
        url: serviceUrl("/clients/#{app.getClientId()}/migrated-email-summaries")
      })
      return $http(reqObj)

    _create = (es) ->
      $cacheFactory.get('EmailSummary.getAll')?.removeAll()
      return _resource.create(es).$promise

    _update = (esId, changes) ->
      $cacheFactory.get('EmailSummary.getAll')?.removeAll()
      $cacheFactory.get('EmailSummary.get')?.remove(serviceUrl("/clients/#{app.getClientId()}/email-summaries/" + esId))
      return _resource.update({esId}, changes).$promise.then((success) -> logger.log('new email summary update', 'email_summary_id', esId))

    _delete = (esId) ->
      $cacheFactory.get('EmailSummary.getAll')?.removeAll()
      $cacheFactory.get('EmailSummary.get')?.remove(serviceUrl("/clients/#{app.getClientId()}/email-summaries/" + esId))
      delStatus = {
        'es_map':{
          'status': emailSummaryEnums.STATUS.DELETED
        }
      }
      return _update(esId, delStatus)

    _send = (esId) ->
      #provide empty object as payload, otherwise first param treated as payload
      return _resource.send({esId}, {}).$promise

    return {
      get: _get
      getAll: _getAll
      getMetaData: _getMetaData
      create: _create
      update: _update
      delete: _delete
      send: _send
      getMigrated: _getMigratedSummaries
    }
  ]
)
